import { render, staticRenderFns } from "./purchasing-prices.vue?vue&type=template&id=cea2ac74&"
import script from "./purchasing-prices.vue?vue&type=script&lang=js&"
export * from "./purchasing-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports